import React from 'react';
import { Hero } from '../components/Hero';
import { ValidationSnapshot } from '../components/ValidationSnapshot';
import { MarketGap } from '../components/MarketGap';
import { ProofStrip } from '../components/ProofStrip';
import { Problem } from '../components/Problem';
import { TaglineExplainer } from '../components/TaglineExplainer';
import { FrontierGatewayTeaser } from '../components/FrontierGatewayTeaser';
import { InternalRunnerTeaser } from '../components/InternalRunnerTeaser';
import { Integrations } from '../components/Integrations';
import { ThreatCenterTeaser } from '../components/ThreatCenterTeaser';
import { WhatPeriscanValidates } from '../components/WhatPeriscanValidates';
import { HomeHowItWorks } from '../components/HomeHowItWorks';
import { PeriscanOperators } from '../components/PeriscanOperators';
import { Competitive } from '../components/Competitive';
import { Safety } from '../components/Safety';
import { WhyNow } from '../components/WhyNow';
import { FounderCard } from '../components/FounderCard';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { SectionStage } from '../components/SectionStage';
export function Home() {
  return <>
      <Hero data-id="element-1644" />

      <SectionStage fx="ripple" data-id="element-1645">
        <ValidationSnapshot data-id="element-1646" />
      </SectionStage>

      <SectionStage fx="matrix" data-id="element-1647">
        <MarketGap data-id="element-1648" />
      </SectionStage>

      <SectionStage fx="beams" data-id="element-1649">
        <ProofStrip data-id="element-1650" />
      </SectionStage>

      <SectionStage fx="squares" data-id="element-1651">
        <Problem data-id="element-1652" />
      </SectionStage>

      <SectionStage fx="spotlight" data-id="element-1653">
        <TaglineExplainer data-id="element-1654" />
      </SectionStage>

      <SectionStage fx="orbit" data-id="element-1655">
        <FrontierGatewayTeaser data-id="element-1656" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1657">
        <InternalRunnerTeaser data-id="element-1658" />
      </SectionStage>

      <SectionStage fx="constellation" data-id="element-1659">
        <Integrations data-id="element-1660" />
      </SectionStage>

      <SectionStage fx="lightning" data-id="element-1661">
        <ThreatCenterTeaser data-id="element-1662" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1663">
        <WhatPeriscanValidates data-id="element-1664" />
      </SectionStage>

      <SectionStage fx="threads" data-id="element-1665">
        <HomeHowItWorks data-id="element-1666" />
      </SectionStage>

      {/* Periscan Operators — rendered without SectionStage so the cinematic
                        blur/opacity transform doesn't dampen the radar sweep behind it. */}
      <PeriscanOperators data-id="element-1667" />

      <SectionStage fx="lightning" data-id="element-1668">
        <Competitive data-id="element-1669" />
      </SectionStage>

      <SectionStage fx="constellation" data-id="element-1670">
        <Safety data-id="element-1671" />
      </SectionStage>

      {/* Brand Legacy — rendered without SectionStage so the cinematic
                          blur/opacity transform doesn't dampen the radar sweep. */}
      <WhyNow data-id="element-1672" />

      <SectionStage fx="glow-orbs" data-id="element-1673">
        <FounderCard data-id="element-1674" />
      </SectionStage>

      <SectionStage fx="squares" data-id="element-1675">
        <FAQ data-id="element-1676" />
      </SectionStage>

      <SectionStage fx="hyperspeed-aurora" data-id="element-1677">
        <FinalCTA data-id="element-1678" />
      </SectionStage>
    </>;
}